import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TreeListRowData } from '../models/orders.model';
import { OrdersPaymentDialogComponent, OrdersRefundDialogComponent } from '../components';

@Injectable({
  providedIn: 'root',
})
export class OrdersDialogService {
  private dialog = inject(MatDialog);

  openPaymentModal(data: TreeListRowData[]) {
    const dialogRef = this.dialog.open<OrdersPaymentDialogComponent>(OrdersPaymentDialogComponent, {
      width: '700px',
      disableClose: true,
      data,
    });
    return dialogRef.afterClosed();
  }

  openRefundModal(selection: TreeListRowData[]) {
    const dialogRef = this.dialog.open<OrdersRefundDialogComponent, TreeListRowData[]>(
      OrdersRefundDialogComponent,
      {
        width: '650px',
        disableClose: true,
        data: selection,
      },
    );
    return dialogRef.afterClosed();
  }
}
